import styled, { css } from 'styled-components';

export const SectionContainer = styled.div`
  min-width: 1280px;
`;

/**
 * -------------------------------------
 *              Section1
 * -------------------------------------
 */
export const MainSection = styled.section`
  position: relative;
  overflow: hidden;
  /* height: calc(100vh - 92px); */
  min-height: 790px;
  max-height: 1080px;
  ${({ isMobileUA }) =>
    isMobileUA &&
    css`
      height: calc(100vh - 92px);
    `};
  & > video {
    /* width: 100%;
    height: auto; */
    min-height: 790px;
    max-height: 1080px;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

export const GradientWrap = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 25%, rgba(20, 20, 20, 0) 75%, #141414 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const MainFrame = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
  min-width: 1200px;
`;

export const CoachMarkScroll = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 35px;
  text-align: center;
  & > svg {
    margin-bottom: ${props => props.theme.spacing[4]};
  }
`;

/**
 * -------------------------------------
 *              Section2
 * -------------------------------------
 */
export const SummarySection = styled.section`
  height: auto;
  padding-top: 4.78125em;
  padding-bottom: 4.78125em;
  background-color: ${props => props.theme.palette['black']};
`;

export const SummaryContents = styled.div`
  width: 1200px;
  display: flex;
  flex-direction: row;
  text-align: center;
  & > div {
    flex: 1;
    padding: ${props => `0 ${props.theme.spacing(5)}`};
    & > p:first-of-type {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.5;
      height: 3em;
    }
    ${props =>
      props.language === 'en' &&
      css`
        &:nth-of-type(2) {
          flex: 1.5;
        }
      `}
  }
  & > p {
    width: 2px;
    height: 31px;
    background-color: ${props => props.theme.palette['white']};
    margin: auto;
  }
`;

/**
 * -------------------------------------
 *              Section3
 * -------------------------------------
 */
export const LandingContents1 = styled.section`
  text-align: center;
  height: auto;
  padding: 7.40625em 0;
  background: url('/assets/image/main_landing_bg01.jpg') no-repeat center center;
  background-size: cover;
  & img {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

/**
 * -------------------------------------
 *              Section4
 * -------------------------------------
 */
export const LandingContents2 = styled.section`
  height: auto;
  background-color: ${props => props.theme.palette['black']};
  text-align: center;
  padding: 4.5em 0;
  width: 100%;
  overflow: hidden;
`;

/**
 * -------------------------------------
 *              Section5
 * -------------------------------------
 */
export const LandingContents3 = styled.section`
  height: auto;
  padding: 4.5em 0;
  position: relative;
  background: url('/assets/image/main_landing_bg02.jpg') no-repeat center center;
  background-size: cover;
  text-align: center;
  & p:first-child {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

/**
 * -------------------------------------
 *              Section6
 * -------------------------------------
 */
export const LandingCta = styled.section`
  height: auto;
  // padding: 3.5em 0;
  position: relative;
  text-align: center;
  background: ${props => props.theme.palette['darkgray2']};
  & p {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

/**
 * -------------------------------------
 *              Section7
 * -------------------------------------
 */
export const LandingFaq = styled.section`
  height: auto;
  padding: 4.5em 0;
  text-align: center;
  background: ${props => props.theme.palette['black']};
`;

export const FaqListContainer = styled.div`
  text-align: left;
  margin-top: ${props => props.theme.spacing(4)};
  width: 70%;
  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.lg}px) {
      width: 1200px;
    }
  `}
  & > div > p:first-of-type::before {
    content: 'Q. ';
  }
  & > div > p:last-of-type {
    padding-left: ${props => props.theme.spacing(7)};
  }
  & > div:not(:last-of-type) {
    margin-bottom: ${props => props.theme.spacing(6)};
  }
`;
